var _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgMarketTuneIcon = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 26.401 22.409",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "np_settings_1459120_000000",
    transform: "matrix(1, 0, 0, 1, -15.6, -20.901001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5740",
    "data-name": "Path 5740",
    d: "M42.635,21.3v5.91H40V29.47h2.635V42.91h2.259V29.47H47.53V27.211H44.894V21.3Z",
    transform: "translate(-14.964 0)",
    fill: "#5d3cd9",
    stroke: "#fff",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5741",
    "data-name": "Path 5741",
    d: "M66.635,21.3v13.44H64V37h2.635v5.91h2.259V37H71.53V34.741H68.894V21.3Z",
    transform: "translate(-29.929)",
    fill: "#5d3cd9",
    stroke: "#fff",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5742",
    "data-name": "Path 5742",
    d: "M18.635,21.3v13.44H16V37h2.635v5.91h2.259V37H23.53V34.741H20.894V21.3Z",
    fill: "#5d3cd9",
    stroke: "#fff",
    strokeWidth: 0.8
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMarketTuneIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/market-tune-icon.79730e83.svg";
export { ForwardRef as ReactComponent };